export const convertBlankTo = (value: any, defaultConvertedValue: any = -1): any => {
  // !value would make 0 be interpreted as truly
  const isBlank =
    value === null ||
    value === undefined ||
    (!value && value !== 0) ||
    (typeof value === 'string' && value.trim() === '');
  return isBlank ? defaultConvertedValue : value;
};
